<template>
	<div class="alert alert-info widget-block date-filter">
		
		<datepicker
			v-model="Value"
			@selected="valueSelected"
			format="dd.MM.yyyy"
			:language="$store.state.lang === 'en' ? 'en' : 'ru'"
			wrapper-class="filter-period-wrapper"
			input-class="filter-period-input filter-for-date"
			:monday-first="true"
			:clear-button="clearBtn"
			name="filterDateField" />

		<button v-if="!notClose" class="btn-close-filter close" @click.stop="$emit('closeFilter')">×</button>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Datepicker from 'vuejs-datepicker'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'filterDate',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['value', 'clearButton', 'notClose'],
	//=========================================================================
	// локальные изменяемые свойства
	//=========================================================================
	data() {
		return {
			clearBtn: true,
			Value: null
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Datepicker
	},
	//=========================================================================
	// событие - компонент создан
	//=========================================================================
	created() {
		// если есть указания по поводу кнопку очистки
		if (this.clearButton !== undefined && this.clearButton !== null) this.clearBtn = this.clearButton

		// дата
		this.updateValue(this.value)
	},
	//=========================================================================
	// наблюдаемые значения
	//=========================================================================
	watch: {
		'value': function(value) {
			this.updateValue(value)
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// выбрали значение
		//---------------------------------------------------------------------
		valueSelected(date) {
			this.Value = date

			// сообщим родителям что значение поменялось
			this.$emit('input', this.formater_Date2StrDate(this.Value))
		},
		//---------------------------------------------------------------------
		// обновление параметра
		//---------------------------------------------------------------------
		updateValue(value) {
			this.Value = null
			// если задана дата
			if (value) this.Value = this.formater_StrDate2Date(value)
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.widget-block.date-filter {
	padding: 3px 8px 4px 8px;
	float: left;
}

.date-filter {
	padding: 10px 8px;
}

.filter-period-input.filter-for-date {
	height: 40px;
}

</style>



// WEBPACK FOOTER //
// filterDate.vue?1375e40c